import React, { useState } from "react";
import { CommonModal } from "../../../AbstractElements";
import { Row, Col, FormGroup, Label, Form } from "reactstrap";
import ReactDatePicker from "react-datepicker";
import { useController, useForm } from "react-hook-form";
import { DateTime } from "../../../Constant";
import { PostDriverApplyLeave } from "../../../Services/Driver.service";
import { showAlert } from "../../../Services/Shared.service";
import moment from "moment";

const AttendanceModal = ({
  Large,
  title,
  LargeModaltoggle,
  driverObj,
  fetchData,
}) => {
  console.log("disco -ekrne", driverObj);

  const {
    register,
    handleSubmit,
    control,
    reset,
    resetField,
    getValues,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    driverId: driverObj ? driverObj : null,
    blockedFrom: "",
    blockedTo: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false); 
  const onSubmit = (formValues) => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    const dateformater = (data) => moment(new Date(data)).format("YYYY-MM-DD");
    const obj = {
      driverId: driverObj,
      blockedFrom: dateformater(formValues.blockedFrom),
      blockedTo: dateformater(formValues.blockedTo),
      blockedReason:formValues.blockedReason
    };
    PostDriverApplyLeave(obj)
      .then(() => {
        reset();
        showAlert("success", "Applied leave Successfully");
        LargeModaltoggle();
        fetchData()
      })
      .catch((err) => {
        showAlert(
          "error",
          err.response?.data?.message
            ? err.response.data.message
            : "Something went wrong"
        );
      }).finally(() => {
        setIsSubmitting(false); 
      });
  };

  const onChangeBlockedFrom = (data) => {
    setValue("blockedFrom", data);
  };
  const onChangeBlockedto = (data) => {
    setValue("blockedTo", data);
  };
  const BlockedFromField = useController({
    name: "blockedFrom",
    control,
    rules: {
      required: {
        value: true,
        message: "Please select a date",
      },
    },
  }).field;
  const BlockedtillField = useController({
    name: "blockedTo",
    control,
    rules: {
      required: {
        value: true,
        message: "Please select a date",
      },
    },
  }).field;

  console.log("disco ---", watch());
  return (
    <CommonModal
      isOpen={Large}
      title={title}
      toggler={LargeModaltoggle}
      size="md"
    >
      <Form onSubmit={handleSubmit(onSubmit)}>
        <>
          <FormGroup className="row col-lg-12">
            <Label className="col-lg-4 col-form-label">From date</Label>
            <Col lg="12">
              <ReactDatePicker
                className="form-control"
                minDate={new Date()}
                selected={getValues("blockedFrom")}
                dateFormat="dd/MM/yyyy"
                //  showTimeInput
                onChange={(date) => onChangeBlockedFrom(date)}
              
                showYearDropdown
                showMonthDropdown
                scrollableYearDropdown
                shouldCloseOnSelect={true}
              />{" "}
              <span style={{ color: "red" }}>
                {errors?.blockedFrom?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup className="row col-lg-12">
            <Label className="col-lg-4 col-form-label">To date</Label>
            <Col lg="12">
              <ReactDatePicker
                className="form-control"
                minDate={new Date()}
                selected={getValues("blockedTo")}
                dateFormat="dd/MM/yyyy"
                //  showTimeInput
                onChange={(date) => onChangeBlockedto(date)}
                shouldCloseOnSelect={true}
                showYearDropdown
                showMonthDropdown
                scrollableYearDropdown
              />
              <span style={{ color: "red" }}>{errors?.blockedTo?.message}</span>
            </Col>
          </FormGroup>
          <FormGroup className="row col-lg-12">
            <Label className="col-lg-12 col-form-label">Leave Reason</Label>
            <Col lg="12">
              <textarea
                className="form-control"
                {...register("blockedReason", {
                  required: {
                    value: true,
                     message: "Leave Reason is required"
                  }, maxLength: {
                    value: 30,
                    message: "Reason cannot exceed 30 characters",
                },
                pattern: {
                  value: /^[A-Za-z\s]*$/,
                  message: "Reason can only contain letters and spaces",
              },
                validate: (value) => value.trim() !== "" || "Reason cannot be empty or contain only spaces"
               
                })}
                type="text"
              />
               <span style={{ color: "red" }}>{errors?.blockedReason?.message}</span>
            </Col>
          </FormGroup>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <button type="submit" className="btn submit-button"   disabled={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Confirm"}
            </button>
          </div>
        </>
      </Form>
    </CommonModal>
  );
};

export default AttendanceModal;
